import { createApi } from "@reduxjs/toolkit/query/react";
import {
  BASE_URL,
  GET_CUSTOMERLIST_HEADERS,
  CUSTOMER_GET_HEADERS_NODE,
  CUSTOMERLIST_UPDATE_HEADERS,
  GET_HEADER_CONFIGURATION,
  POST_VIEW_CONFIGURATION,
  NODE_URL,
  POST_FIELD_CREATION,
  POST_FIELD_UPDATE,
  POST_FIELD_DELETE,
  POST_OPTION_DELETE,
  POST_FILTER_SAVE,
  POST_VIEW_DELETE,
} from "../constants";
import customBaseQuery from "../CustomBaseQuery/customBaseQuery";
import { getUserToken } from "../utilityFunctions/localServices";

export const customerHeaderApi = createApi({
  reducerPath: "customerHeaderApi",
  baseQuery: customBaseQuery,
  tagTypes: ["customerTableHeaderData"],
  endpoints: (builder) => ({
    fetchCustomerHeader: builder.query({
      query: (data) => {
        const queryParams = new URLSearchParams({
          model: data.model,
        }).toString();

        return {
          url: `${GET_CUSTOMERLIST_HEADERS}?${queryParams}`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${data.token}`,
            "Content-Type": "application/json",
          },
          providesTags: ["customerTableHeaderData"],
        };
      },
      // providesTags: ['customerTableHeaderData'],
    }),
    fetchCustomerHeaderNode: builder.query({
      query: ({ token, orgId, companyId, viewName = "Default" }) => ({
        url: `${CUSTOMER_GET_HEADERS_NODE}?org_id=${orgId}&company_id=${companyId}&view_name=${viewName}`,
        method: "GET",

        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
      providesTags: ["CustomerTableData"], // Adjust if needed
    }),

    postCustomerHeader: builder.mutation({
      query: ({ token, data }) => ({
        url: CUSTOMERLIST_UPDATE_HEADERS,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: data,
        invalidatesTags: ["customerTableHeaderData"],
      }),
    }),
  }),
});

export const { useFetchCustomerHeaderQuery, useFetchCustomerHeaderNodeQuery, usePostCustomerHeaderMutation } =
  customerHeaderApi;

export const headerConfigurationView = createApi({
  reducerPath: "getHeaderConfiguration",
  baseQuery: customBaseQuery,
  tagTypes: ["headerConfigurationData"],
  endpoints: (builder) => ({
    fetchHeaderConfiguration: builder.query({
      query: ({ token, params }) => {
        const queryParams = new URLSearchParams({
          ...params,
        }).toString();

        return {
          url: `${GET_HEADER_CONFIGURATION}?${queryParams}`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${getUserToken()}`,
            "Content-Type": "application/json",
          },
        };
      },
    }),

    postViewConfiguration: builder.mutation({
      query: ({ payload, token }) => ({
        url: POST_VIEW_CONFIGURATION,
        method: "POST",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
          "Content-Type": "application/json",
        },
        body: payload,
      }),
    }),
    fetchAllCompnayGroup: builder.query({
      query: ({ token, params }) => {
        const queryParams = new URLSearchParams({
          ...params,
        }).toString();

        return {
          url: `${NODE_URL}customers/fetch/groups?${queryParams}`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${getUserToken()}`,
            "Content-Type": "application/json",
          },
        };
      },
    }),
    postFieldCreation: builder.mutation({
      query: ({ payload, isUpdate }) => ({
        url: isUpdate ? POST_FIELD_UPDATE : POST_FIELD_CREATION,
        method: "POST",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
          "Content-Type": "application/json",
        },
        body: payload,
      }),
    }),
    postFieldDelete: builder.mutation({
      query: ({ payload }) => ({
        url: POST_FIELD_DELETE,
        method: "POST",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
          "Content-Type": "application/json",
        },
        body: payload,
        //    "company_id": 5,
        // "field_name": "customer_name"
      }),
    }),
    postOptionDelete: builder.mutation({
      query: ({ payload }) => ({
        url: POST_OPTION_DELETE,
        method: "POST",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
          "Content-Type": "application/json",
        },
        body: payload,
        // "id": "254f66c3-e9ff-11ef-8647-bc2411f4d589",
        // "company_id": 5
      }),
    }),
    postMetaSave: builder.mutation({
      query: ({ payload, token }) => ({
        url: POST_FILTER_SAVE,
        method: "POST",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
          "Content-Type": "application/json",
        },
        body: payload,
      }),
    }),
    postViewDelete: builder.mutation({
      query: ({ payload }) => ({
        url: POST_VIEW_DELETE,
        method: "POST",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
          "Content-Type": "application/json",
        },
        body: payload,
        //     "type": "public",
        //     "company_id": 5,
        //     "view_name": "My Tasks View"
      }),
    }),
  }),
});

export const {
  useFetchHeaderConfigurationQuery,
  usePostViewConfigurationMutation,
  useFetchAllCompnayGroupQuery,
  usePostFieldCreationMutation,
  usePostFieldDeleteMutation,
  usePostOptionDeleteMutation,
  usePostMetaSaveMutation,
  usePostViewDeleteMutation,
} = headerConfigurationView;
